export const CM_FWU_TARGET_TYPES = {
    ENGINE: 'ENGINE',
};
